export const objectFilter = (filterFn = () => true) => (obj = {}) => Object.fromEntries(Object.entries(obj).filter(([key, val]) => filterFn(val, key, obj)));
//# sourceMappingURL=object-filter.js.map